import type { CharacterItem } from "@/types/content";

export const characters: CharacterItem[] = [
  {
    id: "char-1",
    name: "林素妍",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20gentle%20calm%20east%20asian%20woman%20in%20her%20late%20thirties%20wearing%20a%20soft%20ivory%20knitwear%2C%20muted%20navy%20background%20with%20soft%20studio%20lighting%2C%20quiet%20thoughtful%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail%2C%20professional%20composition&width=600&height=800&seq=iwm-char-01&orientation=portrait",
    role: "主角",
    actor: "韩智秀",
    position: "妻子 / 前舞台剧编剧",
    summary:
      "为了家庭放弃创作的舞台剧编剧，把所有情绪折叠进日常琐碎。看似温顺的外表下，藏着一段从未被讲述的人生。",
    background: [
      "大学时期是剧社里最有天赋的编剧，作品曾获得校园戏剧节最佳原创剧本奖。",
      "婚后十二年，她把创作欲转移到了家庭经营上，却始终在深夜偷偷写一些从未完成的片段。",
      "转折发生在整理旧物时翻出的一封未寄出的信，那封信成了她重新审视自己的起点。",
    ],
    traits: ["隐忍", "敏锐", "温柔", "坚韧"],
  },
  {
    id: "char-2",
    name: "李在勋",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20composed%20east%20asian%20man%20in%20his%20early%20forties%20wearing%20a%20navy%20turtleneck%2C%20muted%20grey%20studio%20background%20with%20soft%20side%20lighting%2C%20serious%20reserved%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail%2C%20professional%20composition&width=600&height=800&seq=iwm-char-02&orientation=portrait",
    role: "主角",
    actor: "朴成勋",
    position: "丈夫 / 建筑事务所合伙人",
    summary:
      "理性可靠的建筑师，习惯用解决问题的方式对待感情。当他开始想了解妻子时，才发现自己记住的是她的习惯，而非她本人。",
    background: [
      "出身于重视规矩的家庭，坚信「把事情做好」就是表达爱的方式。",
      "建筑事务所的合伙人，业内以严谨著称，作品常被形容为「克制而有分量」。",
      "在婚姻的第十二年第一次意识到，自己对妻子的了解可能一直停留在表面。",
    ],
    traits: ["理性", "克制", "可靠", "后知后觉"],
  },
  {
    id: "char-3",
    name: "崔恩珠",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20confident%20warm%20east%20asian%20woman%20in%20her%20late%20thirties%20wearing%20a%20rust%20orange%20blouse%2C%20muted%20warm%20grey%20studio%20background%2C%20soft%20natural%20lighting%2C%20friendly%20knowing%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-03&orientation=portrait",
    role: "配角",
    actor: "车敏书",
    position: "素妍的多年闺蜜 / 咖啡馆主理人",
    summary:
      "全剧最清醒的旁观者。她既是素妍情绪的出口，也是推动素妍直面内心的那只手，一句「你到底想要什么」点醒了整部剧。",
    background: [
      "经营着一家开在老街区的小咖啡馆，是素妍唯一可以卸下防备的地方。",
      "曾经也经历过一次失败的婚姻，因此对感情格外通透，却从不轻易给建议。",
      "在第十集的对话中，她第一次对素妍说出「你一直在替别人活着」。",
    ],
    traits: ["直率", "通透", "温暖", "清醒"],
  },
  {
    id: "char-4",
    name: "金泰周",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20east%20asian%20man%20in%20his%20late%20thirties%20wearing%20a%20light%20grey%20suit%20no%20tie%2C%20muted%20navy%20studio%20background%2C%20soft%20studio%20lighting%2C%20easygoing%20relaxed%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-04&orientation=portrait",
    role: "配角",
    actor: "郑宇彬",
    position: "在勋的合伙人 / 好友",
    summary:
      "在勋身边那个总在打圆场的人。他看似玩世不恭，却在关键时刻提醒在勋：婚姻不是项目，不能用进度表衡量。",
    background: [
      "与在勋共同创办建筑事务所，负责对外沟通，性格八面玲珑。",
      "是少数敢当面指出在勋问题的人，也是事务所里气氛的调节器。",
      "在第十四集与在勋的一场天台对谈，是全剧最直接的男性视角表达。",
    ],
    traits: ["圆融", "幽默", "重情", "通透"],
  },
  {
    id: "char-5",
    name: "姜秀赫",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20sharply%20dressed%20east%20asian%20man%20in%20his%20late%20forties%20wearing%20a%20dark%20navy%20coat%20and%20scarf%2C%20dim%20moody%20background%20with%20low%20key%20lighting%2C%20cold%20enigmatic%20expression%2C%20cinematic%20film%20noir%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-05&orientation=portrait",
    role: "反派",
    actor: "具昌勋",
    position: "神秘商人 / 老宅地块买家",
    summary:
      "推动老宅支线的关键人物。他并非传统意义上的恶人，而是一个用利益逻辑解释一切的商人，其冷漠恰好照出了主角家庭的裂痕。",
    background: [
      "从事老街地块开发，行事低调，谈判时从不提高音量。",
      "他提出的收购条件，成了引爆素妍家庭矛盾的导火索。",
      "第十二集那场茶馆谈判，被观众称为「全剧最冷的一场戏」。",
    ],
    traits: ["冷静", "务实", "深不可测"],
  },
  {
    id: "char-6",
    name: "郑美子",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20elderly%20east%20asian%20woman%20in%20her%20late%20sixties%20with%20grey%20hair%20and%20a%20soft%20wool%20cardigan%2C%20warm%20separating%20background%2C%20gentle%20melancholy%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-06&orientation=portrait",
    role: "配角",
    actor: "文贞淑",
    position: "素妍的母亲 / 老宅守护者",
    summary:
      "沉默了一辈子的母亲。她把委屈折进日常，也把同样的隐忍传给了女儿。老宅里那面墙的秘密，正是她一生未说出口的话。",
    background: [
      "独自守护着即将拆迁的老宅，对每一件旧物都敝帚自珍。",
      "年轻时也有过未竟的梦想，只是那个年代没有给她选择的权利。",
      "在日记被发现后，第一次向女儿讲述了自己的人生。",
    ],
    traits: ["隐忍", "慈爱", "执拗"],
  },
  {
    id: "char-7",
    name: "朴志焕",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20scholarly%20east%20asian%20man%20in%20his%20fifties%20wearing%20round%20glasses%20and%20a%20brown%20tweed%20jacket%2C%20muted%20warm%20grey%20background%2C%20thoughtful%20calm%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-07&orientation=portrait",
    role: "配角",
    actor: "韩承佑",
    position: "律师 / 素妍旧友",
    summary:
      "那个始终守着素妍旧作的人。他保存着一份被素妍遗忘多年的剧本手稿，成为她重新出发的契机。",
    background: [
      "素妍大学剧社时期的学长，如今是一名普通律师。",
      "多年来一直替素妍保管着她当年未完成的剧本手稿。",
      "在剧集后段把这份手稿交还给素妍，完成了一次温柔的接力。",
    ],
    traits: ["温和", "念旧", "可靠"],
  },
  {
    id: "char-8",
    name: "尹世拉",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20young%20east%20asian%20woman%20in%20her%20early%20twenties%20wearing%20a%20simple%20white%20shirt%2C%20bright%20airy%20background%20with%20soft%20light%2C%20hopeful%20earnest%20expression%2C%20cinematic%20film%20still%20style%2C%20high%20detail&width=600&height=800&seq=iwm-char-08&orientation=portrait",
    role: "配角",
    actor: "李妍熙",
    position: "年轻时期素妍的扮演者 / 闪回线",
    summary:
      "闪回线里的素妍。她出现在每一个「黄金时代」的片段中，用明亮的眼神对照当下的疲惫，让观众看到素妍曾经的样子。",
    background: [
      "主要出现在 2011 至 2015 年的闪回片段中，是剧集暖色调的来源。",
      "她的每一次出现，都对应着现在时空里素妍的一次动摇。",
      "最后一场闪回与结局的舞台朗读形成呼应，完成了角色的闭环。",
    ],
    traits: ["明亮", "热忱", "勇敢"],
  },
];